import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { CertificationKindsQuery as CertificationKindsQueryType } from "./__generated__/CertificationKindsQuery";

const CertificationKindsQuery = loader("./CertificationKindsQuery.gql");

type CertificationKindsQueryProviderType = (props: {
  children: (data: CertificationKindsQueryType) => ReactNode;
}) => ReactElement;

export const CertificationKindsQueryProvider: CertificationKindsQueryProviderType = (props) => {
  const { children } = props;

  const { error, loading, data } = useQuery<CertificationKindsQueryType>(CertificationKindsQuery, {
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
